import styled from 'styled-components';
import { Drawer } from '@/shared/Drawers';
import Colors from '@/constants/Colors';

export const StyledLaunchRealTimeActivity = styled(Drawer)`
  &.large {
    .ant-drawer-content-wrapper {
      width: 90% !important;
      min-width: 600px;
    }
  }

  .ant-drawer-body {
    overflow: hidden;
    height: 100%;

    .ant-spin-nested-loading {
      height: 100%;

      .columns {
        display: flex;
        flex-grow: 1;
        gap: 10px;
        height: 100%;

        .tasks {
          flex: 2;
          height: 100%;
          overflow: auto;
        }
        .students-container {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .students {
          overflow: auto;
        }
        .info {
          padding: 20px;
          border-radius: 8px;
          background-color: ${Colors.backgroundPaleBlue};
          flex: 1;
          overflow: auto;

          ol li {
            font-weight: lighter;
          }
        }
      }

      .loading {
        padding: 20px;
        width: 100%;
        text-align: center;
      }
    }
  }
`;
